interface OrderItem {
  name: string;
  quantity: number;
  price: number;
  total?: number;
  image?: string;
  images?: { src: string }[];
  productId?: string;
  product?: any; 
  mainImage?: string; 
}

interface OrderItemsProps {
  items: OrderItem[];
  productImages?: { [key: string]: string };
  shippingCost?: number;
  isManualOrder?: boolean;
}

export default function OrderItems({ items, productImages = {}, shippingCost, isManualOrder }: OrderItemsProps) {
  const getImageUrl = (item: OrderItem) => {
    // Primeiro tenta obter a imagem do próprio item
    if (item.mainImage) return item.mainImage;
    if (item.image) return item.image;
    if (item.images?.[0]?.src) return item.images[0].src;
    
    // Depois tenta obter do objeto product
    if (item.product?.mainImage) return item.product.mainImage;
    if (item.product?.image) return item.product.image;
    if (item.product?.images?.[0]?.src) return item.product.images[0].src;
    
    // Por fim, tenta obter do mapa de imagens ou usa o placeholder
    return (item.productId && productImages[item.productId]) || '/placeholder-product.png';
  };

  const subtotal = items.reduce((sum, item) => sum + (item.total ?? (item.price * item.quantity)), 0);

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Itens da Encomenda</h3>
      <div className="bg-gray-50 rounded-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Imagem</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Produto</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Qtd</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Preço</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {items.map((item, index) => {
              const total = item.total ?? (item.price * item.quantity);
              const imageUrl = getImageUrl(item);
              
              return (
                <tr key={index}>
                  <td className="px-6 py-4">
                    <div className="w-16 h-16 relative">
                      <img 
                        src={imageUrl}
                        alt={item.name}
                        className="w-full h-full object-cover rounded"
                        onError={(e) => {
                          console.log('Erro ao carregar imagem:', imageUrl);
                          const img = e.target as HTMLImageElement;
                          img.src = '/placeholder-product.png';
                        }}
                      />
                    </div>
                  </td>
                  <td className="px-6 py-4">{item.name}</td>
                  <td className="px-6 py-4">{item.quantity}</td>
                  <td className="px-6 py-4">€{(item.price || 0).toFixed(2)}</td>
                  <td className="px-6 py-4">€{(total || 0).toFixed(2)}</td>
                </tr>
              );
            })}
            {isManualOrder && shippingCost !== undefined && shippingCost > 0 && (
              <tr className="bg-gray-50">
                <td colSpan={4} className="px-6 py-4 text-right font-medium">
                  Custos de Envio:
                </td>
                <td className="px-6 py-4">€{shippingCost.toFixed(2)}</td>
              </tr>
            )}
            <tr className="bg-gray-50">
              <td colSpan={4} className="px-6 py-4 text-right font-medium">
                Subtotal:
              </td>
              <td className="px-6 py-4">€{subtotal.toFixed(2)}</td>
            </tr>
            <tr className="bg-gray-50">
              <td colSpan={4} className="px-6 py-4 text-right font-medium">
                Total:
              </td>
              <td className="px-6 py-4">€{((subtotal + (isManualOrder ? (shippingCost || 0) : 0)) || 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}